import React, { useState } from 'react';
import { Menu, User, Bell, Plus, Eye, Trash2, Save, Download, Home, Type, ChevronRight, X, Edit2, ImagePlus, AlignLeft, AlignCenter, AlignRight, AlignJustify } from 'lucide-react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

// Complete Templates
const headerTemplates = [
  { id: 1, bg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', name: 'दैनिक अखबार' },
  { id: 2, bg: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', name: 'दैनिक अखबार' },
  { id: 3, bg: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', name: 'दैनिक सवेरा' },
  { id: 4, bg: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', name: 'दैनिक अखबार' },
];

const subHeaderTemplates = [
  { id: 1, bg: '#3b82f6', text: 'Monday 28th January 2023', style: 'modern' },
  { id: 2, bg: '#fbbf24', text: 'Sunday 23rd July 2023 | संस्करणीय', style: 'classic' },
  { id: 3, bg: '#ffffff', text: 'Sunday 23rd July 2023', border: '#e5e7eb', style: 'minimal' },
  { id: 4, bg: '#f3f4f6', text: 'संस्करणीय | Channel Name', style: 'bold' },
  { id: 5, bg: '#dc2626', text: 'Thursday 28th January 2023', style: 'red' },
  { id: 6, bg: '#16a34a', text: 'संस्करणीय दैनिक', style: 'green' },
];

const footerTemplates = [
  { id: 1, bg: '#3b82f6', dots: ['#ef4444', '#f59e0b', '#10b981', '#000'] },
  { id: 2, bg: '#fbbf24', dots: ['#ef4444', '#f59e0b', '#10b981', '#000'] },
  { id: 3, bg: '#ffffff', text: 'Channel Name © 2023', dots: ['#3b82f6', '#f59e0b', '#ef4444'] },
  { id: 4, bg: '#f3f4f6', dots: ['#ef4444', '#f59e0b', '#10b981', '#6366f1'] },
  { id: 5, bg: '#1f2937', text: 'www.mywebsite.com', dots: ['#3b82f6', '#10b981'] },
];

const layoutOptions = [
  { id: 1, cols: [12], name: 'Full Width' },
  { id: 2, cols: [3, 9], name: 'Sidebar + Main' },
  { id: 3, cols: [4, 8], name: 'Small + Large' },
  { id: 4, cols: [4, 4, 4], name: 'Three Equal' },
  { id: 5, cols: [2, 5, 5], name: 'Tiny + Two' },
  { id: 6, cols: [2, 6, 4], name: 'Mixed Layout' },
];

export default function NewspaperEditor() {
  const [currentTab, setCurrentTab] = useState('header');
  const [bottomTab, setBottomTab] = useState('blocks');
  const [selectedHeaderTemplate, setSelectedHeaderTemplate] = useState(null);
  const [selectedSubHeaderTemplate, setSelectedSubHeaderTemplate] = useState(null);
  const [selectedFooterTemplate, setSelectedFooterTemplate] = useState(null);
  const [pages, setPages] = useState([{ id: 1, rows: [] }]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showLayoutModal, setShowLayoutModal] = useState(false);
  const [showConvertingModal, setShowConvertingModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [channelName, setChannelName] = useState('Channel Name');
  const [selectedLayout, setSelectedLayout] = useState(null);
  const [editingCell, setEditingCell] = useState(null);
  const [showDesignLayout, setShowDesignLayout] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  const addRow = () => {
    if (selectedLayout) {
      const updatedPages = pages.map(page => {
        if (page.id === currentPage) {
          return {
            ...page,
            rows: [...page.rows, {
              id: Date.now(),
              layout: selectedLayout,
              cells: selectedLayout.cols.map((col, idx) => ({
                id: `${Date.now()}-${idx}`,
                heading: '',
                text: '',
                image: null,
                imageWidth: 200,
                imageHeight: 200,
                color: "white",
                textColor: '#000000',
                fontSize: 'medium',
                textAlign: 'justify',
                headingSize: 'large'
              }))
            }]
          };
        }
        return page;
      });
      setPages(updatedPages);
      setShowLayoutModal(false);
    }
  };

  const deleteRow = (rowId) => {
    const updatedPages = pages.map(page => {
      if (page.id === currentPage) {
        return { ...page, rows: page.rows.filter(r => r.id !== rowId) };
      }
      return page;
    });
    setPages(updatedPages);
  };

  const updateCellHeading = (rowId, cellId, heading) => {
    const updatedPages = pages.map(page => {
      if (page.id === currentPage) {
        return {
          ...page,
          rows: page.rows.map(row => {
            if (row.id === rowId) {
              return {
                ...row,
                cells: row.cells.map(cell => 
                  cell.id === cellId ? { ...cell, heading } : cell
                )
              };
            }
            return row;
          })
        };
      }
      return page;
    });
    setPages(updatedPages);
  };

  const updateCellText = (rowId, cellId, text) => {
    const updatedPages = pages.map(page => {
      if (page.id === currentPage) {
        return {
          ...page,
          rows: page.rows.map(row => {
            if (row.id === rowId) {
              return {
                ...row,
                cells: row.cells.map(cell => 
                  cell.id === cellId ? { ...cell, text } : cell
                )
              };
            }
            return row;
          })
        };
      }
      return page;
    });
    setPages(updatedPages);
  };

  const updateCellImage = (rowId, cellId, image) => {
    const updatedPages = pages.map(page => {
      if (page.id === currentPage) {
        return {
          ...page,
          rows: page.rows.map(row => {
            if (row.id === rowId) {
              return {
                ...row,
                cells: row.cells.map(cell => 
                  cell.id === cellId ? { ...cell, image } : cell
                )
              };
            }
            return row;
          })
        };
      }
      return page;
    });
    setPages(updatedPages);
  };

  const updateCellColor = (rowId, cellId, color) => {
    const updatedPages = pages.map(page => {
      if (page.id === currentPage) {
        return {
          ...page,
          rows: page.rows.map(row => {
            if (row.id === rowId) {
              return {
                ...row,
                cells: row.cells.map(cell => 
                  cell.id === cellId ? { ...cell, color } : cell
                )
              };
            }
            return row;
          })
        };
      }
      return page;
    });
    setPages(updatedPages);
  };

  const updateCellProperty = (rowId, cellId, property, value) => {
    const updatedPages = pages.map(page => {
      if (page.id === currentPage) {
        return {
          ...page,
          rows: page.rows.map(row => {
            if (row.id === rowId) {
              return {
                ...row,
                cells: row.cells.map(cell => 
                  cell.id === cellId ? { ...cell, [property]: value } : cell
                )
              };
            }
            return row;
          })
        };
      }
      return page;
    });
    setPages(updatedPages);
  };

  const updateCellImageSize = (rowId, cellId, width, height) => {
    const updatedPages = pages.map(page => {
      if (page.id === currentPage) {
        return {
          ...page,
          rows: page.rows.map(row => {
            if (row.id === rowId) {
              return {
                ...row,
                cells: row.cells.map(cell =>
                  cell.id === cellId
                    ? { ...cell, imageWidth: width, imageHeight: height }
                    : cell
                )
              };
            }
            return row;
          })
        };
      }
      return page;
    });
    setPages(updatedPages);
  };

  const handleImageUpload = (rowId, cellId, event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        updateCellImage(rowId, cellId, e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const addNewPage = () => {
    const newPageId = Math.max(...pages.map(p => p.id)) + 1;
    setPages([...pages, { id: newPageId, rows: [] }]);
    setCurrentPage(newPageId);
  };

  const deletePage = (pageId) => {
    if (pages.length > 1) {
      const updatedPages = pages.filter(p => p.id !== pageId);
      setPages(updatedPages);
      if (currentPage === pageId) {
        setCurrentPage(updatedPages[0].id);
      }
    }
  };

  const getFontSize = (size) => {
    switch(size) {
      case 'small': return '9px';
      case 'medium': return '11px';
      case 'large': return '13px';
      case 'xlarge': return '15px';
      default: return '11px';
    }
  };

  const getHeadingSize = (size) => {
    switch(size) {
      case 'small': return '13px';
      case 'medium': return '16px';
      case 'large': return '19px';
      case 'xlarge': return '22px';
      default: return '16px';
    }
  };

  const generatePDF = async () => {
    setShowConvertingModal(true);

    try {
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      for (let i = 0; i < pages.length; i++) {
        const page = pages[i];
        
        // Create temporary container with exact A4 proportions
        const tempContainer = document.createElement('div');
        tempContainer.style.width = '794px'; // A4 width in pixels at 96 DPI
        tempContainer.style.minHeight = '1123px'; // A4 height in pixels at 96 DPI
        tempContainer.style.backgroundColor = 'white';
        tempContainer.style.padding = '0';
        tempContainer.style.margin = '0';
        tempContainer.style.position = 'absolute';
        tempContainer.style.left = '-9999px';
        tempContainer.style.fontFamily = 'Arial, sans-serif';
        tempContainer.style.boxSizing = 'border-box';
        document.body.appendChild(tempContainer);

        if (selectedHeaderTemplate) {
          const headerTemplate = headerTemplates.find(t => t.id === selectedHeaderTemplate);
          const headerDiv = document.createElement('div');
          headerDiv.style.background = headerTemplate.bg;
          headerDiv.style.padding = '20px';
          headerDiv.style.textAlign = 'center';
          headerDiv.style.color = 'white';
          headerDiv.style.marginBottom = '10px';
          headerDiv.innerHTML = `
            <div style="display: flex; justify-content: space-between; align-items: center; margin: 0 auto;">
              <div style="width: 60px; height: 60px; background: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 30px; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">📰</div>
              <div style="flex: 1; padding: 0 20px;">
                <h1 style="font-size: 36px; margin: 0; font-weight: bold; text-shadow: 2px 2px 4px rgba(0,0,0,0.2);">${channelName}</h1>
                <p style="margin: 6px 0; font-size: 13px; opacity: 0.95;">इंदरगढ़ > दतिया > ग्वालियर > मंदि > मोरेना</p>
                <p style="margin: 4px 0; font-size: 11px; opacity: 0.9;">Sunday 23rd July 2023 | पेज नं. ${page.id} | pradeep@gmail.com</p>
              </div>
              <div style="background: white; color: #dc2626; padding: 10px 15px; border-radius: 8px; font-weight: bold; font-size: 13px; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
                सूचनाएं<br/><span style="font-size: 10px;">Important</span>
              </div>
            </div>
          `;
          tempContainer.appendChild(headerDiv);
        }

        if (selectedSubHeaderTemplate) {
          const subHeaderTemplate = subHeaderTemplates.find(t => t.id === selectedSubHeaderTemplate);
          const subHeaderDiv = document.createElement('div');
          subHeaderDiv.style.background = subHeaderTemplate.bg;
          subHeaderDiv.style.padding = '10px 20px';
          subHeaderDiv.style.marginBottom = '10px';
          if (subHeaderTemplate.border) {
            subHeaderDiv.style.border = `2px solid ${subHeaderTemplate.border}`;
          }
          subHeaderDiv.innerHTML = `
            <p style="margin: 0; font-size: 13px; font-weight: bold; color: ${subHeaderTemplate.bg === '#ffffff' ? '#000' : '#fff'}; text-align: center;">
              ${subHeaderTemplate.text}
            </p>
          `;
          tempContainer.appendChild(subHeaderDiv);
        }

        const contentContainer = document.createElement('div');
        contentContainer.style.width = '100%';
        contentContainer.style.margin = '0';
        contentContainer.style.background = 'white';
        contentContainer.style.padding = '10px';
        contentContainer.style.boxSizing = 'border-box';

        page.rows.forEach(row => {
          const rowDiv = document.createElement('div');
          rowDiv.style.display = 'grid';
          rowDiv.style.gap = '4px';
          rowDiv.style.gridTemplateColumns = row.layout.cols.map(c => `${(c/12) * 100}%`).join(' ');
          rowDiv.style.marginBottom = '10px';
          rowDiv.style.width = '100%';
          rowDiv.style.boxSizing = 'border-box';

          row.cells.forEach(cell => {
            const cellDiv = document.createElement('div');
            cellDiv.style.background = cell.color || 'white';
            cellDiv.style.borderRadius = '6px';
            cellDiv.style.padding = '5px';
            cellDiv.style.minHeight = '100px';
            cellDiv.style.boxShadow = '0 1px 3px rgba(0,0,0,0.08)';
            cellDiv.style.boxSizing = 'border-box';
            cellDiv.style.overflow = 'hidden';

            let cellContent = '';
            if (cell.heading) {
              cellContent += `
                <h2 style="color: ${cell.textColor || '#000000'}; font-size: ${getHeadingSize(cell.headingSize || 'large')}; font-weight: bold; margin: 0 0 8px 0; text-align: ${cell.textAlign || 'center'}; line-height: 1.3;">
                  ${cell.heading}
                </h2>
              `;
            }
            if (cell.image) {
  cellContent += `
    <img 
      src="${cell.image}" 
      style="
        float: ${cell.imageAlign || 'left'};
        max-width: ${cell.imageWidth || 180}px;
        max-height: ${cell.imageHeight || 180}px;
        margin: 10px 10px 6px 0;
        object-fit: contain;
        border-radius: 4px;
        box-shadow: 0 2px 6px rgba(0,0,0,0.12);
      "
    />
  `;
}
           if (cell.text) {
  cellContent += `
    <p style="
      clear: none;
      font-size: ${getFontSize(cell.fontSize || 'medium')};
      line-height: 1.6;
      text-align: justify;
    ">
      ${cell.text}
    </p>
    <div style="clear: both;"></div>
  `;
}

            cellDiv.innerHTML = cellContent;
            rowDiv.appendChild(cellDiv);
          });

          contentContainer.appendChild(rowDiv);
        });

        tempContainer.appendChild(contentContainer);

        if (selectedFooterTemplate) {
          const footerTemplate = footerTemplates.find(t => t.id === selectedFooterTemplate);
          const footerDiv = document.createElement('div');
          footerDiv.style.background = footerTemplate.bg;
          footerDiv.style.padding = '12px 20px';
          footerDiv.style.marginTop = '15px';
          footerDiv.style.display = 'flex';
          footerDiv.style.justifyContent = 'space-between';
          footerDiv.style.alignItems = 'center';
          footerDiv.style.borderRadius = '6px';
          
          let footerContent = '';
          if (footerTemplate.text) {
            footerContent += `<span style="font-size: 12px; font-weight: bold; color: ${footerTemplate.bg === '#ffffff' ? '#000' : '#fff'};">${footerTemplate.text}</span>`;
          }
          footerContent += '<div style="display: flex; gap: 6px; margin-left: auto;">';
          footerTemplate.dots.forEach(d => {
            footerContent += `<div style="width: 10px; height: 10px; border-radius: 50%; background: ${d}; box-shadow: 0 1px 3px rgba(0,0,0,0.2);"></div>`;
          });
          footerContent += '</div>';
          
          footerDiv.innerHTML = footerContent;
          tempContainer.appendChild(footerDiv);
        }

        // Convert to canvas with proper scaling
        const canvas = await html2canvas(tempContainer, {
          scale: 2,
          useCORS: true,
          logging: false,
          backgroundColor: 'white',
          width: 794,
          height: 1123,
          windowWidth: 794,
          windowHeight: 1123
        });

        const imgData = canvas.toDataURL('image/png');
        
        // Calculate proper dimensions to fit A4
        const imgWidth = pdfWidth;
        const imgHeight = pdfHeight;

        if (i > 0) {
          pdf.addPage();
        }

        // Add image to fit exactly on A4 page
        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
        document.body.removeChild(tempContainer);
      }

      pdf.save(`${channelName.replace(/\s+/g, '_')}_newspaper.pdf`);
      
      setShowConvertingModal(false);
      setShowSuccessModal(true);
    } catch (error) {
      console.error('PDF generation error:', error);
      setShowConvertingModal(false);
      alert('PDF बनाने में कोई समस्या आई। कृपया फिर से कोशिश करें।');
    }
  };

  const currentPageData = pages.find(p => p.id === currentPage);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f3f4f6' }}>
      {/* Top Nav */}
      <div style={{ backgroundColor: '#0f766e', color: 'white', padding: '10px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Menu style={{ width: '22px', height: '22px', cursor: 'pointer' }} onClick={() => setShowSidebar(!showSidebar)} />
          <div style={{ backgroundColor: '#10b981', padding: '5px 12px', borderRadius: '6px', fontSize: '13px', fontWeight: 600 }}>
            ₹0 <span style={{ fontSize: '11px', opacity: 0.9 }}>2023-11-16</span>
          </div>
          <button style={{ display: 'flex', alignItems: 'center', gap: '6px', backgroundColor: 'white', color: '#1f2937', padding: '6px 12px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: 500 }}>
            <User style={{ width: '16px', height: '16px' }} />
            Profile
          </button>
          <button style={{ backgroundColor: '#dc2626', padding: '6px 12px', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', border: 'none', color: 'white', cursor: 'pointer' }}>HELP</button>
        </div>
        <Bell style={{ width: '20px', height: '20px', cursor: 'pointer' }} />
      </div>

      {/* Channel Header */}
      <div style={{ backgroundColor: '#d1d5db', padding: '14px 16px', borderBottom: '2px solid #9ca3af' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <div style={{ width: '56px', height: '56px', backgroundColor: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.15)', fontSize: '28px' }}>📰</div>
          <div style={{ flex: 1 }}>
            <input type="text" value={channelName} onChange={(e) => setChannelName(e.target.value)} style={{ fontSize: '24px', fontWeight: 'bold', color: '#b91c1c', backgroundColor: 'transparent', border: 'none', outline: 'none', width: '100%', marginBottom: '4px' }} />
            <p style={{ fontSize: '13px', color: '#374151', margin: 0 }}>इंदरगढ़ > दतिया > ग्वालियर > मंदि > मोरेना</p>
            <p style={{ fontSize: '11px', color: '#6b7280', margin: '2px 0 0 0' }}>Sunday 23rd July 2023 | पेज नं. | pradeep@gmail.com</p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ flex: 1, overflow: 'auto', backgroundColor: '#fef3c7', padding: '12px' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          {/* Page Tabs */}
          <div style={{ display: 'flex', gap: '8px', marginBottom: '12px', overflowX: 'auto', paddingBottom: '8px' }}>
            {pages.map(page => (
              <div key={page.id} style={{ position: 'relative' }}>
                <button onClick={() => setCurrentPage(page.id)} style={{ padding: '8px 20px', borderRadius: '6px', border: currentPage === page.id ? '2px solid #0f766e' : '2px solid #9ca3af', backgroundColor: currentPage === page.id ? '#d1fae5' : 'white', cursor: 'pointer', fontWeight: currentPage === page.id ? 'bold' : 'normal', fontSize: '14px', whiteSpace: 'nowrap' }}>
                  {page.id} Page
                </button>
                {pages.length > 1 && (
                  <button onClick={() => deletePage(page.id)} style={{ position: 'absolute', top: '-6px', right: '-6px', width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#dc2626', color: 'white', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold' }}>
                    ×
                  </button>
                )}
              </div>
            ))}
            <button onClick={addNewPage} style={{ padding: '8px 20px', borderRadius: '6px', border: '2px dashed #0f766e', backgroundColor: 'white', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px', color: '#0f766e', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Plus style={{ width: '16px', height: '16px' }} /> NEW
            </button>
          </div>

          {/* Page Label */}
          <div style={{ textAlign: 'center', marginBottom: '12px' }}>
            <span style={{ backgroundColor: '#4b5563', color: 'white', padding: '6px 18px', borderRadius: '20px', fontSize: '15px', fontWeight: 600, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
              {currentPage} Page
            </span>
          </div>

          {/* Canvas */}
          <div style={{ backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', padding: '16px', marginBottom: '12px', minHeight: '500px' }}>
            {/* Header */}
            {selectedHeaderTemplate && (
              <div style={{ marginBottom: '16px', padding: '20px', borderRadius: '10px', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: headerTemplates.find(h => h.id === selectedHeaderTemplate)?.bg, boxShadow: '0 4px 8px rgba(0,0,0,0.15)' }}>
                <div style={{ width: '50px', height: '50px', backgroundColor: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', boxShadow: '0 2px 6px rgba(0,0,0,0.1)' }}>📰</div>
                <div style={{ flex: 1, padding: '0 16px' }}>
                  <h2 style={{ fontSize: '26px', fontWeight: 'bold', margin: 0, textShadow: '1px 1px 2px rgba(0,0,0,0.2)' }}>{channelName}</h2>
                  <p style={{ fontSize: '12px', margin: '4px 0 0 0', opacity: 0.95 }}>इंदरगढ़ > दतिया > ग्वालियर</p>
                </div>
                <div style={{ backgroundColor: 'white', color: '#dc2626', padding: '10px 16px', borderRadius: '8px', fontSize: '12px', fontWeight: 'bold', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                  सूचनाएं
                </div>
              </div>
            )}

            {/* SubHeader */}
            {selectedSubHeaderTemplate && (
              <div style={{ marginBottom: '16px', padding: '12px 20px', borderRadius: '6px', background: subHeaderTemplates.find(h => h.id === selectedSubHeaderTemplate)?.bg, border: subHeaderTemplates.find(h => h.id === selectedSubHeaderTemplate)?.border ? `2px solid ${subHeaderTemplates.find(h => h.id === selectedSubHeaderTemplate)?.border}` : 'none' }}>
                <p style={{ margin: 0, fontSize: '13px', fontWeight: 'bold', color: subHeaderTemplates.find(h => h.id === selectedSubHeaderTemplate)?.bg === '#ffffff' ? '#000' : '#fff', textAlign: 'center' }}>
                  {subHeaderTemplates.find(h => h.id === selectedSubHeaderTemplate)?.text}
                </p>
              </div>
            )}

            {/* Rows */}
            {currentPageData?.rows.length === 0 ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '350px', border: '3px dashed #d1d5db', borderRadius: '12px', backgroundColor: '#f9fafb' }}>
                <div style={{ textAlign: 'center', color: '#9ca3af' }}>
                  <Plus style={{ width: '50px', height: '50px', margin: '0 auto 12px', opacity: 0.5 }} />
                  <p style={{ fontSize: '16px', fontWeight: 600, margin: 0 }}>Click "+ ADD NEW ROW" to add content</p>
                </div>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {currentPageData?.rows.map((row, rowIdx) => (
                  <div key={row.id} style={{ position: 'relative' }}>
                    {showDesignLayout && (
                      <div style={{ position: 'absolute', top: '-42px', right: 0, backgroundColor: '#1f2937', color: 'white', padding: '6px 12px', borderRadius: '6px', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', zIndex: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.2)' }}>
                        <span style={{ fontWeight: 600 }}>Row {rowIdx + 1}</span>
                        <button onClick={() => deleteRow(row.id)} style={{ backgroundColor: '#dc2626', padding: '4px 8px', borderRadius: '4px', border: 'none', cursor: 'pointer', color: 'white', display: 'flex', alignItems: 'center' }}>
                          <Trash2 style={{ width: '14px', height: '14px' }} />
                        </button>
                      </div>
                    )}
                    <div style={{ display: 'grid', gap: '12px', gridTemplateColumns: row.layout.cols.map(c => `${(c/12) * 100}%`).join(' ') }}>
                      {row.cells.map((cell) => (
                        <div key={cell.id} style={{ backgroundColor: cell.color || 'white', padding: '16px', borderRadius: '8px', border: '2px solid #e5e7eb', minHeight: '180px', position: 'relative', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                          {editingCell === cell.id ? (
                            <button onClick={() => setEditingCell(null)} style={{ position: 'absolute', top: '8px', right: '8px', backgroundColor: '#10b981', color: 'white', border: 'none', borderRadius: '6px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer', fontWeight: 'bold', zIndex: 10 }}>
                              Done
                            </button>
                          ) : (
                            <button onClick={() => setEditingCell(cell.id)} style={{ position: 'absolute', top: '8px', right: '8px', backgroundColor: '#0f766e', color: 'white', border: 'none', borderRadius: '6px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: 'bold', zIndex: 10 }}>
                              <Edit2 style={{ width: '12px', height: '12px' }} /> Edit
                            </button>
                          )}

                          {editingCell === cell.id && (
                            <div style={{ marginBottom: '12px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                              {/* Color Controls */}
                              <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                                <label style={{ fontSize: '11px', fontWeight: 600 }}>BG:</label>
                                <input type="color" value={cell.color || '#ffffff'} onChange={(e) => updateCellColor(row.id, cell.id, e.target.value)} style={{ width: '40px', height: '32px', border: '2px solid #e5e7eb', borderRadius: '4px', cursor: 'pointer' }} />
                              </div>
                              <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                                <label style={{ fontSize: '11px', fontWeight: 600 }}>Text:</label>
                                <input type="color" value={cell.textColor || '#000000'} onChange={(e) => updateCellProperty(row.id, cell.id, 'textColor', e.target.value)} style={{ width: '40px', height: '32px', border: '2px solid #e5e7eb', borderRadius: '4px', cursor: 'pointer' }} />
                              </div>

                              {/* Font Size */}
                              <select value={cell.fontSize || 'medium'} onChange={(e) => updateCellProperty(row.id, cell.id, 'fontSize', e.target.value)} style={{ padding: '6px', fontSize: '11px', border: '2px solid #e5e7eb', borderRadius: '4px', fontWeight: 600 }}>
                                <option value="small">Small (9px)</option>
                                <option value="medium">Medium (11px)</option>
                                <option value="large">Large (13px)</option>
                                <option value="xlarge">XLarge (15px)</option>
                              </select>

                              {/* Heading Size */}
                              <select value={cell.headingSize || 'large'} onChange={(e) => updateCellProperty(row.id, cell.id, 'headingSize', e.target.value)} style={{ padding: '6px', fontSize: '11px', border: '2px solid #e5e7eb', borderRadius: '4px', fontWeight: 600 }}>
                                <option value="small">H-Small (13px)</option>
                                <option value="medium">H-Medium (16px)</option>
                                <option value="large">H-Large (19px)</option>
                                <option value="xlarge">H-XLarge (22px)</option>
                              </select>

                              {/* Text Align */}
                              <div style={{ display: 'flex', gap: '4px' }}>
                                <button onClick={() => updateCellProperty(row.id, cell.id, 'textAlign', 'left')} style={{ padding: '6px', border: cell.textAlign === 'left' ? '2px solid #0f766e' : '2px solid #e5e7eb', borderRadius: '4px', backgroundColor: cell.textAlign === 'left' ? '#d1fae5' : 'white', cursor: 'pointer' }} title="Align Left">
                                  <AlignLeft style={{ width: '14px', height: '14px' }} />
                                </button>
                                <button onClick={() => updateCellProperty(row.id, cell.id, 'textAlign', 'center')} style={{ padding: '6px', border: cell.textAlign === 'center' ? '2px solid #0f766e' : '2px solid #e5e7eb', borderRadius: '4px', backgroundColor: cell.textAlign === 'center' ? '#d1fae5' : 'white', cursor: 'pointer' }} title="Align Center">
                                  <AlignCenter style={{ width: '14px', height: '14px' }} />
                                </button>
                                <button onClick={() => updateCellProperty(row.id, cell.id, 'textAlign', 'right')} style={{ padding: '6px', border: cell.textAlign === 'right' ? '2px solid #0f766e' : '2px solid #e5e7eb', borderRadius: '4px', backgroundColor: cell.textAlign === 'right' ? '#d1fae5' : 'white', cursor: 'pointer' }} title="Align Right">
                                  <AlignRight style={{ width: '14px', height: '14px' }} />
                                </button>
                                <button onClick={() => updateCellProperty(row.id, cell.id, 'textAlign', 'justify')} style={{ padding: '6px', border: cell.textAlign === 'justify' ? '2px solid #0f766e' : '2px solid #e5e7eb', borderRadius: '4px', backgroundColor: cell.textAlign === 'justify' ? '#d1fae5' : 'white', cursor: 'pointer' }} title="Justify">
                                  <AlignJustify style={{ width: '14px', height: '14px' }} />
                                </button>
                              </div>

                              {/* Image Upload */}
                              <label style={{ backgroundColor: '#6366f1', color: 'white', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '11px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <ImagePlus style={{ width: '14px', height: '14px' }} />
                                Image
                                <input type="file" accept="image/*" onChange={(e) => handleImageUpload(row.id, cell.id, e)} style={{ display: 'none' }} />
                              </label>

                              {/* Image Size Controls */}
                              {cell.image && (
                                <>
                                  <input type="number" placeholder="Width" value={cell.imageWidth || 200} onChange={(e) => updateCellImageSize(row.id, cell.id, parseInt(e.target.value), cell.imageHeight || 200)} style={{ width: '70px', padding: '6px', fontSize: '11px', border: '2px solid #e5e7eb', borderRadius: '4px' }} />
                                  <input type="number" placeholder="Height" value={cell.imageHeight || 200} onChange={(e) => updateCellImageSize(row.id, cell.id, cell.imageWidth || 200, parseInt(e.target.value))} style={{ width: '70px', padding: '6px', fontSize: '11px', border: '2px solid #e5e7eb', borderRadius: '4px' }} />
                                </>
                              )}
                            </div>
                          )}

                          {editingCell === cell.id ? (
                            <>
                              <input type="text" placeholder="Heading..." value={cell.heading} onChange={(e) => updateCellHeading(row.id, cell.id, e.target.value)} style={{ width: '100%', padding: '10px', marginBottom: '10px', border: '2px solid #e5e7eb', borderRadius: '6px', fontSize: getHeadingSize(cell.headingSize || 'large'), fontWeight: 'bold' }} />
                              {cell.image && (
                                <div style={{ marginBottom: '10px', position: 'relative' }}>
                                  <img src={cell.image} alt="Cell" style={{ maxWidth: `${cell.imageWidth || 200}px`, maxHeight: `${cell.imageHeight || 200}px`, width: 'auto', height: 'auto', borderRadius: '6px', display: 'block', margin: '0 auto' }} />
                                  <button onClick={() => updateCellImage(row.id, cell.id, null)} style={{ position: 'absolute', top: '8px', right: '8px', backgroundColor: '#ef4444', color: 'white', border: 'none', borderRadius: '50%', width: '28px', height: '28px', cursor: 'pointer', fontWeight: 'bold', fontSize: '18px' }}>
                                    ×
                                  </button>
                                </div>
                              )}
                              <textarea placeholder="Content..." value={cell.text} onChange={(e) => updateCellText(row.id, cell.id, e.target.value)} style={{ width: '100%', minHeight: '150px', padding: '10px', border: '2px solid #e5e7eb', borderRadius: '6px', fontSize: getFontSize(cell.fontSize || 'medium'), resize: 'vertical', fontFamily: 'inherit', lineHeight: '1.8' }} />
                            </>
                          ) : (
                            <>
                              {cell.heading && <div style={{ fontWeight: 'bold', fontSize: getHeadingSize(cell.headingSize || 'large'), marginBottom: '10px', color: cell.textColor || '#000', textAlign: cell.textAlign || 'center', lineHeight: '1.4' }}>{cell.heading}</div>}
                              {cell.image && <div style={{ textAlign: 'center', marginBottom: '10px' }}><img src={cell.image} alt="Cell" style={{ maxWidth: `${cell.imageWidth || 200}px`, maxHeight: `${cell.imageHeight || 200}px`, width: 'auto', height: 'auto', borderRadius: '6px', objectFit: 'contain' }} /></div>}
                              {cell.text && <div style={{ fontSize: getFontSize(cell.fontSize || 'medium'), lineHeight: '1.8', color: cell.textColor || '#000', textAlign: cell.textAlign || 'justify', whiteSpace: 'pre-wrap' }}>{cell.text}</div>}
                              {!cell.heading && !cell.text && !cell.image && <div style={{ color: '#9ca3af', textAlign: 'center', paddingTop: '40px', fontSize: '14px' }}>Click Edit to add content</div>}
                            </>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Footer */}
            {selectedFooterTemplate && (
              <div style={{ marginTop: '16px', padding: '14px 20px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: footerTemplates.find(f => f.id === selectedFooterTemplate)?.bg }}>
                {footerTemplates.find(f => f.id === selectedFooterTemplate)?.text && (
                  <span style={{ fontSize: '13px', fontWeight: 'bold', color: footerTemplates.find(f => f.id === selectedFooterTemplate)?.bg === '#ffffff' ? '#000' : '#fff' }}>
                    {footerTemplates.find(f => f.id === selectedFooterTemplate)?.text}
                  </span>
                )}
                <div style={{ display: 'flex', gap: '8px', marginLeft: footerTemplates.find(f => f.id === selectedFooterTemplate)?.text ? '15px' : 0 }}>
                  {footerTemplates.find(f => f.id === selectedFooterTemplate)?.dots.map((d, i) => (
                    <div key={i} style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: d, boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }} />
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Bottom Buttons */}
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: '12px' }}>
            <button onClick={() => setShowLayoutModal(true)} style={{ backgroundColor: '#0f766e', color: 'white', padding: '12px 24px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontSize: '15px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '8px', boxShadow: '0 2px 6px rgba(0,0,0,0.15)' }}>
              <Plus style={{ width: '18px', height: '18px' }} /> ADD NEW ROW
            </button>
            <button onClick={() => setShowDesignLayout(!showDesignLayout)} style={{ backgroundColor: showDesignLayout ? '#dc2626' : '#6b7280', color: 'white', padding: '12px 24px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontSize: '15px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '8px', boxShadow: '0 2px 6px rgba(0,0,0,0.15)' }}>
              <Eye style={{ width: '18px', height: '18px' }} /> {showDesignLayout ? 'HIDE' : 'DESIGN'}
            </button>
            <button onClick={generatePDF} style={{ backgroundColor: '#10b981', color: 'white', padding: '12px 24px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontSize: '15px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '8px', boxShadow: '0 2px 6px rgba(0,0,0,0.15)' }}>
              <Download style={{ width: '18px', height: '18px' }} /> DOWNLOAD
            </button>
          </div>
        </div>
      </div>

      {/* Sidebar */}
      {showSidebar && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', maxWidth: '400px', height: '100vh', backgroundColor: 'white', boxShadow: '4px 0 12px rgba(0,0,0,0.15)', zIndex: 100, overflowY: 'auto' }}>
          <div style={{ display: 'flex', borderBottom: '2px solid #e5e7eb', position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 10 }}>
            {['Header', '2nd Header', 'SubHeader', 'Footer'].map(tab => (
              <button key={tab} onClick={() => setCurrentTab(tab.toLowerCase().replace(' ', '').replace('nd', ''))} style={{ flex: 1, padding: '12px', fontSize: '11px', fontWeight: 700, backgroundColor: currentTab === tab.toLowerCase().replace(' ', '').replace('nd', '') ? '#374151' : '#f3f4f6', color: currentTab === tab.toLowerCase().replace(' ', '').replace('nd', '') ? 'white' : 'black', border: 'none', cursor: 'pointer' }}>
                {tab}
              </button>
            ))}
          </div>
          <button onClick={() => setShowSidebar(false)} style={{ position: 'absolute', top: '52px', right: '16px', background: 'none', border: 'none', cursor: 'pointer', zIndex: 20 }}>
            <X style={{ width: '24px', height: '24px' }} />
          </button>
          <div style={{ padding: '20px', paddingTop: '50px' }}>
            {currentTab === 'header' && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                {headerTemplates.map(t => (
                  <div key={t.id} onClick={() => {setSelectedHeaderTemplate(t.id); setShowSidebar(false);}} style={{ padding: '16px', borderRadius: '10px', cursor: 'pointer', background: t.bg, color: 'white', outline: selectedHeaderTemplate === t.id ? '3px solid #3b82f6' : 'none', outlineOffset: '2px', boxShadow: '0 4px 8px rgba(0,0,0,0.15)', transition: 'transform 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'} onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <div style={{ width: '45px', height: '45px', backgroundColor: 'white', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', boxShadow: '0 2px 6px rgba(0,0,0,0.1)' }}>📰</div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 'bold', fontSize: '15px', textShadow: '1px 1px 2px rgba(0,0,0,0.2)' }}>{t.name}</div>
                        <div style={{ fontSize: '11px', opacity: 0.9, marginTop: '2px' }}>इंदरगढ़ > दतिया</div>
                      </div>
                      <div style={{ backgroundColor: 'white', color: '#dc2626', padding: '6px 12px', borderRadius: '6px', fontSize: '10px', fontWeight: 'bold', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                        HERE
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {currentTab === 'subheader' && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {subHeaderTemplates.map(t => (
                  <div key={t.id} onClick={() => {setSelectedSubHeaderTemplate(t.id); setShowSidebar(false);}} style={{ padding: '14px', borderRadius: '8px', cursor: 'pointer', backgroundColor: t.bg, border: t.border ? `2px solid ${t.border}` : 'none', outline: selectedSubHeaderTemplate === t.id ? '3px solid #3b82f6' : 'none', outlineOffset: '2px', boxShadow: '0 2px 6px rgba(0,0,0,0.1)', transition: 'transform 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'} onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                    <div style={{ fontSize: '13px', fontWeight: 'bold', color: t.bg === '#ffffff' ? '#000' : '#fff', textAlign: 'center' }}>
                      {t.text}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {currentTab === 'footer' && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {footerTemplates.map(t => (
                  <div key={t.id} onClick={() => {setSelectedFooterTemplate(t.id); setShowSidebar(false);}} style={{ padding: '14px 18px', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: t.bg, outline: selectedFooterTemplate === t.id ? '3px solid #3b82f6' : 'none', outlineOffset: '2px', boxShadow: '0 2px 6px rgba(0,0,0,0.1)', transition: 'transform 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'} onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                    {t.text && <span style={{ fontSize: '12px', fontWeight: 'bold', color: t.bg === '#ffffff' ? '#000' : '#fff' }}>{t.text}</span>}
                    <div style={{ display: 'flex', gap: '6px', marginLeft: t.text ? '12px' : 0 }}>
                      {t.dots.map((d, i) => (
                        <div key={i} style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: d, boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }} />
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Layout Modal */}
      {showLayoutModal && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200, padding: '20px' }}>
          <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '28px', maxWidth: '550px', width: '100%', maxHeight: '90vh', overflow: 'auto', boxShadow: '0 8px 24px rgba(0,0,0,0.2)' }}>
            <h3 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '20px', textAlign: 'center', color: '#1f2937' }}>ADD NEW ROW</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '20px' }}>
              {layoutOptions.map((layout) => (
                <div key={layout.id} onClick={() => setSelectedLayout(layout)} style={{ cursor: 'pointer', border: selectedLayout?.id === layout.id ? '3px solid #3b82f6' : '3px solid #e5e7eb', borderRadius: '10px', padding: '16px', backgroundColor: selectedLayout?.id === layout.id ? '#eff6ff' : 'white', boxShadow: '0 2px 6px rgba(0,0,0,0.08)', transition: 'all 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'} onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                  <div style={{ display: 'grid', gap: '10px', gridTemplateColumns: layout.cols.map(c => `${(c/12) * 100}%`).join(' '), marginBottom: '8px' }}>
                    {layout.cols.map((col, idx) => (
                      <div key={idx} style={{ backgroundColor: '#000', color: 'white', borderRadius: '6px', padding: '20px', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>
                        {col}
                      </div>
                    ))}
                  </div>
                  <div style={{ fontSize: '13px', color: '#6b7280', textAlign: 'center', fontWeight: 600 }}>{layout.name}</div>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => setShowLayoutModal(false)} style={{ flex: 1, padding: '12px', backgroundColor: '#e5e7eb', borderRadius: '8px', border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: '15px', color: '#374151' }}>
                Cancel
              </button>
              <button onClick={addRow} style={{ flex: 1, padding: '12px', backgroundColor: '#16a34a', color: 'white', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: '15px', boxShadow: '0 2px 6px rgba(0,0,0,0.15)' }}>
                Next <ChevronRight style={{ width: '20px', height: '20px' }} />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Converting Modal */}
      {showConvertingModal && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }}>
          <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '40px', maxWidth: '320px', boxShadow: '0 8px 24px rgba(0,0,0,0.2)' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{ width: '70px', height: '70px', border: '5px solid #ef4444', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 1s linear infinite', marginBottom: '20px' }}></div>
              <p style={{ fontSize: '20px', fontWeight: 700, margin: 0, color: '#1f2937' }}>Converting to PDF...</p>
            </div>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {showSuccessModal && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200, padding: '20px' }}>
          <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '40px', maxWidth: '420px', width: '100%', boxShadow: '0 8px 24px rgba(0,0,0,0.2)' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '28px' }}>
              <div style={{ width: '70px', height: '70px', backgroundColor: '#10b981', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px', boxShadow: '0 4px 12px rgba(16,185,129,0.3)' }}>
                <svg style={{ width: '40px', height: '40px', color: 'white' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 style={{ fontSize: '26px', fontWeight: 'bold', marginBottom: '10px', margin: '0 0 10px 0', color: '#1f2937' }}>PDF Downloaded Successfully!</h3>
            </div>
            <button onClick={() => setShowSuccessModal(false)} style={{ width: '100%', backgroundColor: 'white', color: '#dc2626', border: '2px solid #dc2626', padding: '14px', borderRadius: '8px', fontWeight: 700, cursor: 'pointer', fontSize: '16px', transition: 'all 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fee2e2'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}>
              CLOSE
            </button>
          </div>
        </div>
      )}

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}